module.exports = __webpack_public_path__ + "img/thumbnail_CommonWombat_j_albino.5fc7307c.png";